import { render, staticRenderFns } from "./blockGq2.vue?vue&type=template&id=5498aa23&"
import script from "./blockGq2.vue?vue&type=script&lang=js&"
export * from "./blockGq2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports